export default __webpack_public_path__ + "static/media/careerbanner.9339d3c4.jpg";